export const EMBEDLY_KEY = '96f1f04c5f4143bcb0f2e68c87d65feb';
export const EMBEDLY_HOST = 'https://api.embed.ly/1/oembed?';
